import { httpClient } from "./httpClient";

const getAllProjectAssign = () => {
  return httpClient.get("projectassigns");
};

export default {
  getAllProjectAssign,
};
